/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/db/StorageProvider */
var t=class{constructor(...r){throw new Error("StorageProvider is abstract and cannot be instantiated")}};export{t as default};
//# sourceMappingURL=StorageProvider.mjs.map